export enum PriorityLabel {
	Favorite = "Favorite",
	New = "New",
}
